module.exports = __webpack_public_path__ + "img/faq.d6e86671.svg";